export default {
    close(state) {
        state.show = false;
        state.mask = true;
        if (state.to) {
            clearTimeout(state.to);
        }
    },
    show(state, param = {}) {
        Object.assign(state, param, {
            show: true
        });
        const timeOut = state.timeOut || 30000;
        if (state.to) {
            clearTimeout(state.to);
        }
        state.to = setTimeout(() => {
            state.show = false;
        }, timeOut);
    },
};



// WEBPACK FOOTER //
// ./src/ui/loading/store/mutations.js